function Logout() {}

export default Logout;
